module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-content"
  }, [_c('div', {
    staticClass: "rel menu-content-dialog"
  }, [(_vm.isActiveAction) ? _c('div', {
    staticClass: "abs menu-content-elements",
    style: ({
      left: _vm.left + 'px',
      top: _vm.y + 'px',
      height: _vm.height + 'px',
      width: _vm.width + 'px'
    })
  }, [_vm._t("default")], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "menu-content-icon-text",
    style: ({
      color: _vm.color,
      'background-color': _vm.backgroundColorActive
    }),
    on: {
      "click": _vm.activeItem
    }
  }, [_c('i', {
    staticClass: "menu-icon",
    class: _vm.icon,
    style: ({
      'font-size': _vm.size + 'px'
    })
  }), _vm._v(" "), (_vm.text !== null) ? _c('div', {
    staticClass: "menu-content-text"
  }, [_vm._v(_vm._s(_vm.text.toUpperCase()))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c0b9ed4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/gui/menu/MenuItem.vue
// module id = 3050
// module chunks = 0